// Hooks
import { createFormContext, useForm } from 'hooks';

export const ThingsContext = createFormContext();

export const useThings = useForm;
export default useThings;
